import '../vendor/lity'

const [w, d] = [window, document]

const init = () => {

  //スロット適用
  $.when( w.load['technology'] ).then( ( html, slot ) => {
    let $obj = $( '[data-slot="technology-list"]' )
    slot ? $obj.replaceWith( slot ) : $obj.hide()
  })

  //iframe（youtube）がリスト内に含まれていたらモーダルで開く
  w.load['loadHtml'].then( () => {
    let $itemIframe = $('.technology-listWrap iframe')

    $.each($itemIframe, (i, v) => {
      let videoId = $(v).attr('src').replace(/^https?:\/\/www\.youtube\.com\/embed\/([^/?]+)(.*)?$/, '$1');

      if (!videoId == '') {
        let $modalLink = $(` <a href="https://youtube.com/embed/${videoId}/" class="modalLink" data-lity></a>`)

        $(v).wrap('<div class="modalWrap"></div>')
        $(v).closest('.modalWrap').append( $modalLink )
      }
    })
  })
}

export default function TECHNOLOGY() {
  $(init)
}
